import React from 'react';
import { Quote } from 'lucide-react';

const QuoteSection = () => {
  return (
    <section className="py-12 md:py-16 bg-fordje-gray-light">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto text-center animate-fade-in">
          <Quote className="h-8 w-8 text-fordje-blue/40 mx-auto mb-6" />
          <blockquote className="text-lg md:text-xl text-fordje-navy leading-relaxed mb-6">
            "Fordje made my research waaaaaay easier. If I had to parse websites for four AHJs the old fashioned way, that could easily be 4 hours plus documenting and transcribing. Using Fordje allowed me to use a single source and complete the work in minutes."
          </blockquote>
          <cite className="text-fordje-blue-dark font-semibold not-italic text-base">
            — GAF Energy
          </cite>
        </div>
      </div>
    </section>
  );
};

export default QuoteSection;
